// Module
var code = "<div class=\"readonly-field\"> <div class=\"{{vm.fieldClass}}\" ng-show=\"vm.isFieldShow\"> <span class=\"break-all {{vm.textClass ? vm.textClass : 'crm-text'}}\"> {{ vm.fieldValue ? vm.fieldValue : 'None' }} </span> </div> </div> ";
// Exports
module.exports = code;